import { Form, Formik } from 'formik'
import React, { useState } from 'react'
import { isEmpty } from 'lodash'
import Input from './componentsFinance/common/Input'
import Button from './componentsFinance/common/Button'
import { domain } from '../utils/request'
import Checkbox from './common/Checkbox'
import { validateFile } from '../utils/validators'

export default function ManthlyIncomeTaxItemForm({ onCancel, loading, initialValues, incomeTaxId, finance, onSubmit }) {
    const [file, setFile] = useState(null)

    async function onSuccess(data) {
        const newData = new FormData()
        if (file) {
            newData.append('incomeTaxPdf', file, file.name)
        }
        newData.append('finance', finance.id)
        newData.append('incomeTax', incomeTaxId)
        newData.append('incomeTaxComment', data.incomeTaxComment)
        newData.append('tax', data.tax)
        newData.append('inps', data.inps)

        onSubmit(newData)
    }

    return (
        <Formik onSubmit={onSuccess}
            initialValues={{
                incomeTaxComment: '',
                tax: false,
                inps: false,
                ...initialValues,
                incomeTaxPdf: initialValues && !isEmpty(initialValues.incomeTaxPdf) ? initialValues.incomeTaxPdf : '',
            }} validate={validateFile('incomeTaxPdf')}>

            {({
                setFieldValue, errors, touched,
            }) => (
                <Form>
                    <div className="columns">
                        <div className="column">
                            <Input
                                name="incomeTaxComment"
                                label="Комментарий"
                                disabled={loading}
                                placeholder="Комментарий" />
                        </div>

                    </div>

                    <Checkbox
                        name="tax"
                        label="Солиқлар тўланиши"
                        disabled={loading}
                        placeholder="Комментарий" />

                    <Checkbox
                        name="inps"
                        label="ИНПС реестр"
                        disabled={loading}
                        placeholder="Комментарий" />


                    <div className="columns">
                        <div className="column">
                            <p className="level-left">
                            Жисмоний шахсланинг даромад солиғи
                            </p>

                            <input
                                name="incomeTaxPdf"
                                onChange={(e) => {
                                    setFieldValue('incomeTaxPdf', e.target.value)
                                    setFile(e.target.files[0])
                                }}
                                type="file"
                                disabled={loading} />

                            {errors.incomeTaxPdf && touched.incomeTaxPdf && (
                                <div className="has-text-danger">{errors.incomeTaxPdf}</div>
                            )}
                            {initialValues ? (domain + initialValues.incomeTaxPdf).split('/').pop() : ''}

                        </div>

                    </div>

                    <Button
                        loading={loading}
                        text="Сохранить"
                        type="submit"
                        icon="ion-md-checkmark"
                        className="is-success" /> &nbsp;

                    <Button
                        onClick={onCancel}
                        icon="ion-md-close"
                        text="Отмена"
                        className="is-danger" />
                </Form>
            )}
        </Formik>
    )
}
